import { ShadowCard, Spinner } from "isuppli-react-components";
import React, { Fragment, useEffect, useState } from "react";
import useShowError from "../../../Hooks/useShowError";
import { getDashboardSupplierTypesSummary } from "../../../http/Dashboard/dashboardApi";
// eslint-disable-next-line no-unused-vars
import { DashboardReportSummary } from "../../../http/Dashboard/Models/Models";
// eslint-disable-next-line no-unused-vars
import DashboardSummaryCard, { DashboardSummaryItem } from "../DashboardSummaryItem/DashboardSummaryItem";

const SupplierTypesSummary = () => {
  const [SupplierTypesSummaryData,
    setSupplierTypesSummaryData] = useState<DashboardReportSummary>();
  const showError = useShowError();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const loader = async () => {
      setLoading(true);
      try {
        // api calls
        const dashboardSupplierTypesSummaryData = await getDashboardSupplierTypesSummary();
        setSupplierTypesSummaryData(dashboardSupplierTypesSummaryData);
      } catch (error) {
        showError();
      }
      setLoading(false);
    };
    loader();
  }, [showError]);

  const SupplierTypeComp = SupplierTypesSummaryData?.items?.map<DashboardSummaryItem>((i) => ({
    key: i.name,
    title: i.name,
    value: i.count,
    linkUrl: `/marketplace/search?f=[[],[],[],[],[],[],null,null,null,null,null,null,${i.id},null,null,null,null,null,null,null,null,null,null]&sf=1`,
  }) as DashboardSummaryItem) ?? [];

  return (
    <Fragment>
      {/* Suppliers */}
      <div className="row mt-4">
        <div className="col-12">
          <h2>MY SUPPLIERS BY TYPE</h2>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <ShadowCard>

            {loading ? <Spinner inline /> : (
              <div className="row">
                <DashboardSummaryCard
                  heading=""
                  className="col-lg-9"
                  summaryItems={SupplierTypeComp}
                />
              </div>
            )}

          </ShadowCard>
        </div>
      </div>
    </Fragment>
  );
};

export default SupplierTypesSummary;
